import React, { useRef, useEffect } from 'react';
import moment from 'moment';

const DateStrip = ({ selectedDate, onDateSelect }) => {
  const todayRef = useRef(null);
  const scrollRef = useRef(null);

  // Build 14 days: 7 past + today + 6 future
  const days = [];
  for (let i = -7; i <= 6; i++) {
    days.push(moment().add(i, 'days'));
  }

  useEffect(() => {
    if (todayRef.current) {
      todayRef.current.scrollIntoView({ inline: 'center', behavior: 'auto' });
    }
  }, []);

  const handleTodayClick = () => {
    onDateSelect(moment());
    if (todayRef.current) {
      todayRef.current.scrollIntoView({ inline: 'center', behavior: 'smooth' });
    }
  };

  const isToday = (day) => day.isSame(moment(), 'day');
  const isSelected = (day) => day.isSame(selectedDate, 'day');

  return (
    <div className="date-strip-wrapper">
      <button className="date-strip-today-btn" onClick={handleTodayClick}>
        Today
      </button>
      <div className="date-strip-scroll" ref={scrollRef}>
        {days.map((day, i) => {
          const today = isToday(day);
          const selected = isSelected(day);
          let cls = 'date-strip-cell';
          if (selected) cls += ' selected';
          if (today && !selected) cls += ' today';

          return (
            <div
              key={i}
              ref={today ? todayRef : null}
              className={cls}
              onClick={() => onDateSelect(day)}
            >
              <span className="date-strip-day">{day.format('ddd')}</span>
              <span className="date-strip-num">{day.format('D')}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DateStrip;
